import querystring from "query-string";

const CURRENT_PAGE_QUERY_PARAM = "p";

export const getPaginationOffset = ({ page, limit }) => {
    return (page - 1) * limit;
};

export const getCurrentPage = ({ queryString, pageQueryParamKey }) => {
    return +querystring.parse(queryString)[pageQueryParamKey] || 1;
};

export const updateUrlForScrollPosition = ({
    sessionHistory,
    routerLocation,
    page,
    pageQueryParamKey
}) => {
    const currentQueryStringObj = querystring.parse(routerLocation.search);
    const newQueryStringObj = {
        ...currentQueryStringObj,
        [pageQueryParamKey]: page
    };
    const newQueryString = querystring.stringify(newQueryStringObj);
    const updatedLocation = {
        ...routerLocation,
        search: newQueryString
    };

    sessionHistory.replace(updatedLocation);
};
